import React, { memo } from 'react'

import { Badge } from 'react-bootstrap'

const EVENT_STATUS = {
  'UNKNOWN': 'UNKNOWN',
  'DRAFT': 'DRAFT',
  'PUBLISH': 'PUBLISH',
  'CANCEL': 'CANCEL',
  'FAILED': 'FAILED',
  'IN_PROGRESS': 'IN_PROGRESS',
};

const statusBadgeVariants = {
  [EVENT_STATUS.UNKNOWN]: 'secondary',
  [EVENT_STATUS.DRAFT]: 'success',
  [EVENT_STATUS.PUBLISH]: 'primary',
  [EVENT_STATUS.CANCEL]: 'danger',
  [EVENT_STATUS.FAILED]: 'warning',
  [EVENT_STATUS.IN_PROGRESS]: 'info',
};

const TagStatus = ({ status }) => {
  const badgeVariant = statusBadgeVariants[status] || 'secondary';
  const formattedStatus = status.charAt(0).toUpperCase() + status.toLowerCase().slice(1)
  return <Badge variant={badgeVariant}>{formattedStatus}</Badge>
}

export default memo(TagStatus)
